export default __webpack_public_path__ + "static/media/1969.63f496f6.png";